"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DadosSkuPercEstSeg = void 0;
var DadosSkuPercEstSeg = /** @class */ (function () {
    function DadosSkuPercEstSeg() {
        this._id = {
            material: '',
            data: '',
            estacao: '',
            colecao: '',
            grade: '',
        };
        this.percentual = 0;
    }
    return DadosSkuPercEstSeg;
}());
exports.DadosSkuPercEstSeg = DadosSkuPercEstSeg;
//# sourceMappingURL=DadosSkuPercEstSeg.js.map